/**
 * 判断是否是一个有效的数组
 * @param {any} value
 * @returns {boolean}
 */
export const isValidArray = (value: any): boolean => {
  if (!value || !Array.isArray(value) || value.length === 0) return false;
  return true;
};
